import React from 'react';
import { StyleSheet, Text, View } from 'react-native';
import { moderateScale } from 'react-native-size-matters';
import Theme from '../../theme';
import { ChevronRightIcon, } from '../../ui/components/Icons';

export interface IDashboardHeaderProps {
    title: string;
    image: any;
    actionTitle: string;
    showAction?: boolean | undefined;
}
class DashboardHeader extends React.PureComponent<IDashboardHeaderProps, any> {

    public render() {
        const { image, title, actionTitle, showAction = true } = this.props;
        return (
            <View style={styles.container}>
                <View style={styles.iconTitleContainer}>
                    <View style={styles.iconContainer}>
                        {image}
                    </View>
                    <Text style={styles.title}>{title.toUpperCase()}</Text>
                </View>
                <View style={{ flexDirection: 'row', alignItems: 'center'}}>
                {showAction &&
                    <Text style={styles.chevronHeading}>{actionTitle}</Text>}
                    <ChevronRightIcon width={18} height={18} color={Theme.PRIMARY} />
                </View>
            </View>
        );
    }
}

const styles = StyleSheet.create({
    container: {
        paddingHorizontal: 10,
        paddingVertical: 5,
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    iconTitleContainer: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    iconContainer: {
        width: 30,
        justifyContent: 'center',
    },
    shieldIcon: {
        width: 28,
        height: 35,
    },
    icon: {
        alignSelf: 'center',
    },
    title: {
        fontSize: moderateScale(15, 1),
        paddingLeft: 10,
        color: Theme.GREY_DARK,
        alignItems: 'center',
        fontFamily: Theme.Custom700,
    },
    chevronHeading: {
        color: Theme.PRIMARY,
        fontFamily: Theme.Custom700,
        marginRight: 10,
        marginLeft: 10,
    },
});

export default DashboardHeader;
